import { render, staticRenderFns } from "./PromotionView.vue?vue&type=template&id=db9f86c2&scoped=true"
import script from "./PromotionView.vue?vue&type=script&lang=js"
export * from "./PromotionView.vue?vue&type=script&lang=js"
import style0 from "./PromotionView.vue?vue&type=style&index=0&id=db9f86c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9f86c2",
  null
  
)

export default component.exports